import BonusAndDeductionTable from 'components/table/bonus_and_deduction_rule/BonusAndDeductionTable'
import React from 'react'

const BonusAndDeductionRules = () => {
    return (
        <>
            <BonusAndDeductionTable />
        </>
    )
}

export { BonusAndDeductionRules }